import { render, staticRenderFns } from "./ReadMore.vue?vue&type=template&id=4ee5f2a7&scoped=true&"
import script from "./ReadMore.vue?vue&type=script&lang=js&"
export * from "./ReadMore.vue?vue&type=script&lang=js&"
import style0 from "./ReadMore.vue?vue&type=style&index=0&id=4ee5f2a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee5f2a7",
  null
  
)

export default component.exports